import { Menu } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { logout } from '../auth/logout';
import { ROLE_LABELS } from '../auth/roles';
import { useAuth } from '../auth/useAuth';
import { NavigationSearch } from './NavigationSearch';
import type { VisibleNavigation } from './navigation';

interface GlobalTopBarProps {
  navigation: VisibleNavigation;
  onOpenMenu: () => void;
}

export function GlobalTopBar({ navigation, onOpenMenu }: GlobalTopBarProps) {
  const { role, user } = useAuth();
  const { pathname } = useLocation();
  const isSaasInternalRoute = pathname.startsWith('/internal/tenant-debug');
  const displayName = user?.name?.trim() || user?.email || '已登录';

  return (
    <header className="console-topbar" role="banner">
      <button
        aria-label="打开导航"
        className="console-menu-trigger"
        onClick={onOpenMenu}
        type="button"
      >
        <Menu aria-hidden size={18} />
      </button>
      <NavLink className="console-brand" to="/">
        TokenForge
      </NavLink>
      <NavigationSearch items={navigation.searchable} />
      <nav aria-label="快捷入口" className="console-utility-nav">
        {navigation.utility.map((item) =>
          item.external ? (
            <a href={item.to} key={item.id} rel="noreferrer" target="_blank">
              {item.label}
            </a>
          ) : (
            <NavLink key={item.id} to={item.to}>
              {item.label}
            </NavLink>
          ),
        )}
      </nav>
      <details className="console-user-menu">
        <summary>{displayName}</summary>
        <div>
          <strong>{displayName}</strong>
          <span>{role ? ROLE_LABELS[role] : '已登录'}</span>
          <button onClick={() => void logout(isSaasInternalRoute)} type="button">
            退出登录
          </button>
        </div>
      </details>
    </header>
  );
}
